import type { ReactNode } from 'react';
import { useTheme } from '../hooks/use-theme.js';

interface ThemeProviderProps {
  children: ReactNode;
}

/** Applies the active theme class to <html> and keeps it in sync with system preference. */
export function ThemeProvider({ children }: ThemeProviderProps) {
  // useTheme handles applying the class via its useEffect
  useTheme();
  return <>{children}</>;
}
